
import { Excel } from "antd-table-saveas-excel";

const eqExport = (
    list,
    formStateList,
    formStepList,
    fileName = "DRF_In_Progress.xlsx"
) => {

    const getStateName = (stateId) => {
        if (!formStateList) return '';

        const item = formStateList.find(
            (a) => a.stateValue === stateId
        );

        return item
            ? `${item.stateValue} ${item.stateName}`
            : '';
    };

    const getStepName = (stepId) => {
        if (!formStepList) return '';

        const item = formStepList.find(
            (a) => a.stepValue === stepId
        );

        return item
            ? `${item.stepValue} ${item.stepName}`
            : '';
    };

    const column = [
        {
            title: 'SAM Dr Ref',
            dataIndex: 'samDrfref',
            key: 'samDrfref'
        },
        {
            title: 'Current State',
            dataIndex: 'stateName',
            key: 'stateName'
        },
        {
            title: 'SAM ID',
            dataIndex: 'equipmentId',
            key: 'equipmentId'
        },
        {
            title: 'Current Step',
            dataIndex: 'stepName',
            key: 'stepName'
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location'
        },
        {
            title: 'Requester Company',
            dataIndex: 'requesterCompany',
            key: 'requesterCompany'
        },
        {
            title: 'Function',
            dataIndex: 'equipmentFunctionName',
            key: 'equipmentFunctionName'
        },
        {
            title: 'OEM',
            dataIndex: 'equipmentOemname',
            key: 'equipmentOemname'
        },
        {
            title: 'Model',
            dataIndex: 'equipmentModelName',
            key: 'equipmentModelName'
        },
        {
            title: 'Request Date',
            dataIndex: 'creationDate',
            key: 'creationDate'
        },
        {
            title: 'Requester Name',
            dataIndex: 'requesterDisplayName',
            key: 'requesterDisplayName'
        },
        {
            title: 'Serial Number',
            dataIndex: 'serialNumber',
            key: 'serialNumber'
        },
        {
            title: 'Last Update',
            dataIndex: 'lastUpdateDate',
            key: 'lastUpdateDate'
        },
        {
            title: 'SAP/P1 Ref',
            dataIndex: 'sapP1ref',
            key: 'sapP1ref'
        },
        {
            title: 'Last Update By',
            dataIndex: 'lastUpdateBy',
            key: 'lastUpdateBy'
        },

        // DR fields
        {
            title: 'DR Rule',
            dataIndex: 'drRule',
            key: 'drRule'
        },
        {
            title: 'DR Decision',
            dataIndex: 'drDecision',
            key: 'drDecision'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status'
        },
        {
            title: 'Condition',
            dataIndex: 'condition',
            key: 'condition'
        }
    ];

    const dataSource = list.map((a) => ({
        ...a,

        stateName: getStateName(a.stateId),
        stepName: getStepName(a.stepId),

        drRule: a.drRule ?? '',
        drDecision: a.drDecision ?? '',
        status: a.status ?? '',

        // If API returns condition directly
        condition: a.condition ?? ''
    }));

    console.log("Export Data:", dataSource);

    const excel = new Excel();

    excel
        .addSheet("DRF")
        .addColumns(column)
        .addDataSource(dataSource, {
            str2Percent: true
        })
        .saveAs(fileName);
};

export default eqExport;

export const mrExport = (list, formStateList, formStepList, fileName = "MR_In_Progress.xlsx") => {

    const getStateName = (stateId) => {
        if (!formStateList) return '';
        const abc = formStateList.find((a) => a.stateValue === stateId);
        return abc ? `${abc.stateValue} ${abc.stateName}` : '';
    }
    const getStepName = (stepId) => {
        if (!formStepList) return '';
        const abc = formStepList.find((a) => a.stepValue === stepId);
        return abc ? `${abc.stepValue} ${abc.stepName}` : '';
    }

    const column = [
        {
            title: 'MRF Ref',
            dataIndex: "samMrfref",
            key: "samMrfref"
        },
        {
            title: 'Current State ',
            dataIndex: "stateName",
            key: "stateName"
        },
        {
            title: 'SAM ID',
            dataIndex: "equipmentId",
            key: "equipmentId"
        },
        {
            title: 'Current Step',
            dataIndex: 'stepName',
            key: 'stepName',
        },
        {
            title: 'Donor',
            dataIndex: "equipmentCompanyName",
            key: "equipmentCompanyName"
        },
        {
            title: 'Requester Company',
            dataIndex: 'requesterCompany', key: 'requesterCompany',
        },
        {
            title: 'Function',
            dataIndex: 'equipmentFunction', key: 'equipmentFunction',
        },
        {
            title: 'OEM',
            dataIndex: "equipmentOemname",
            key: "equipmentOemname"
        },
        {
            title: 'Model',
            dataIndex: "equipmentOemmodel",
            key: "equipmentOemmodel"
        },
        {
            title: 'Request Date',
            dataIndex: 'creationDate',
            key: 'creationDate',
        },
        {
            title: 'Request Date Valid until',
            dataIndex: 'requestValidityDate',
            key: 'requestValidityDate',
        },
        {
            title: 'Requester Name',
            dataIndex: 'requesterDisplayName',
            key: 'requesterDisplayName',
        },
        {
            title: 'Serial Number',
            dataIndex: 'serialNumber',
            key: 'serialNumber'
        },
        {
            title: 'Last Update ',
            dataIndex: 'lastUpdateDate',
            key: 'lastUpdateDate'
        },
        {
            title: 'SAP/P1 Ref',
            dataIndex: 'sapP1ref',
            key: 'sapP1ref'
        },
        {
            title: 'Last Update By Publication Period',
            dataIndex: 'lastUpdateBy',
            key: 'lastUpdateBy'
        },
        {
            title: 'Status',
            dataIndex: 'equipmentStatusName',
            key: 'equipmentStatusName'

        },
            {
        title: 'Decision',
        dataIndex: 'decision',
        key: 'decision',
    },
                {
        title: 'Decision Date',
        dataIndex: 'decisionDate',
        key: 'decisionDate',
    },
    {
        title: 'IsTransferred',
        dataIndex: 'isTransferred',
        key: 'isTransferred',

    }
    ];

    const dataSource = list.map((a) => {
        return { ...a, stateName: getStateName(a.stateId), stepName: getStepName(a.stepId) }
    })

    const excel = new Excel();
    excel
        .addSheet("test")
        .addColumns(column)
        .addDataSource(dataSource, {
            str2Percent: true
        })
        .saveAs(fileName);

}

// export  mrExport;